<template>
    <v-text-field
        v-on="$listeners"
        v-model="inner_value"
        :label="label"
        :hint="hint"
        :disabled="disabled"
        :readonly="readonly"
        :placeholder="placeholder"
        :error="error"
        type="number"
        :min="num_min"
        :max="num_max"
        :step="limits && limits.float ? '0.1' : ''"
        @change="change_inner();$emit('change', $event)"
        :persistent-hint="persistentHint"
        :outlined="outlined" :dense="dense" hide-details="auto">
        <template v-slot:append :aria-label="label">
            <v-icon
                :aria-label="label"
                :disabled="false"
                @click="$emit('click:append', $event);">
                {{ appendIcon }}
            </v-icon>
        </template>
    </v-text-field>
</template>

<script>
export default {
    name: "number-field",
    props: [
        'label',
        'value',
        'disabled',
        'limits',
        'min', //For highly dynamical bounds
        'max', //For highly dynamical bounds
        'placeholder',
        'hint',
        'bounds',
        'outlined',
        'dense',
        'append-icon',
        'error',
        'warning',
        'persistentHint',
        'readonly'
    ],
    data: function () {
        return {
            inner_value: '',
        }
    },
    computed: {
        num_min: function () {
            if (this.min !== undefined && !isNaN(this.min)) {
                return Number(this.min);
            } else if (this.limits && this.limits.min !== undefined && !isNaN(this.limits.min)) {
                return this.limits.min;
            } else {
                return false;
            }
        },
        num_max: function () {
            if (this.max !== undefined && !isNaN(this.max)) {
                return Number(this.max);
            } else if (this.limits && this.limits.max && !isNaN(this.limits.max)) {
                return this.limits.max;
            } else {
                return false;
            }
        },
    },
    watch: {
        value: function (val) {
            this.inner_value = val;
        },
        warning: function (val) {
            if (val) {
                $(this.$el).find("fieldset").addClass('warning--text');
            } else {
                $(this.$el).find("fieldset").removeClass('warning--text');
            }
        },
        min: function () {
            this.change_inner();
        },
        max: function () {
            this.change_inner();
        }
    },
    methods: {
        change_inner: function () {
            let validated = this.validate(this.inner_value, this.value);
            this.inner_value = validated;
            this.$emit('input', validated);
        },
        validate: function (val, oldVal) {
            let validated = val;
            if (this.limits) {
                if (this.limits.color === 1) {
                    if (!val) {
                        val = '';
                    }
                    if (!oldVal) {
                        oldVal = '';
                    }
                    val = parseInt(val.replace('#', ''), 16);
                    oldVal = parseInt(oldVal.replace('#', ''), 16);
                }
                validated = this.clampToLimits(val, oldVal, this.limits);
                if (this.limits.color === 1) {
                    validated = '#' + validated.toString(16).padStart(6, '0');
                }
            }
            return validated;
        },
        clampToLimits(value, oldValue, limits) {
            if (value !== '' && value !== undefined) {
                if (typeof limits === 'object' && limits != null && limits.float) {
                    value = Math.round(parseFloat(value, 10) * 10) / 10.0;
                } else {
                    value = parseInt(value, 10);
                }
                if (isNaN(value)) {
                    value = oldValue;
                }

                if (this.num_min !== false && value < this.num_min)
                    return this.num_min;
                if (this.num_max !== false && value > this.num_max)
                    return this.num_max;
            }
            return value;
        },
    },
    mounted () {
        this.inner_value = this.value;
    }
}
</script>

<style scoped>

</style>
